// extracted by css-extract-rspack-plugin
export default {"normal":"WhiteFlash_normal__u2ywc","doTransition":"WhiteFlash_doTransition__Rica1"};